import type { ActivityProductivity, AdminActivityEvent } from '@doneverse/shared'

/** The three statuses, in the order every control lists them (ClickUp 14zf25zjet4). */
export const PRODUCTIVITY_STATUSES: readonly ActivityProductivity[] = [
  'productive',
  'unproductive',
  'undefined',
]

const LABELS: Record<ActivityProductivity, string> = {
  productive: 'Productive',
  unproductive: 'Unproductive',
  undefined: 'Undefined',
}

/** The word the table, the badge and the CSV all show. Empty for a row with no
 *  status: only desktop `foreground_app` rows are classified, and "Undefined"
 *  means "nobody has classified this yet", which an idle row never can be. */
export function productivityLabel(productivity: ActivityProductivity | null): string {
  return productivity ? LABELS[productivity] : ''
}

/** The Productivity filter, applied in the browser over the WHOLE range (the
 *  status is resolved after the database query, so the server cannot page by
 *  it). A row with no status never matches. */
export function filterEventsByProductivity(
  events: AdminActivityEvent[],
  productivity: ActivityProductivity,
): AdminActivityEvent[] {
  return events.filter((event) => event.productivity === productivity)
}
